import bg from '../assets/bg.png';
import insideShot from '../assets/insideShot.png';
import gallery01 from '../assets/gallery01.jpg';
import gallery02 from '../assets/gallery02.jpg';
import gallery03 from '../assets/gallery03.jpg';
import gallery04 from '../assets/gallery04.jpg';
import gallery05 from '../assets/gallery05.jpg';
import gallery06 from '../assets/gallery06.jpg';
import gallery07 from '../assets/gallery07.jpg';
import gallery08 from '../assets/gallery08.jpg';
import gallery09 from '../assets/gallery09.jpg';
import gallery10 from '../assets/gallery10.jpg';
import gallery11 from '../assets/gallery11.jpg';
import gallery12 from '../assets/gallery12.jpg';
import gallery13 from '../assets/gallery13.jpg';
import gallery14 from '../assets/gallery14.jpg';
import gallery15 from '../assets/gallery15.jpg';
import gallery16 from '../assets/gallery16.jpg';
import knife from '../assets/knife.png';
import menu from '../assets/menu.jpg';
import overlaybg from '../assets/overlaybg.png';
import spoon from '../assets/spoon.svg';
import welcome from '../assets/welcome.png';
import laurels from '../assets/laurels.jpg';
import award01 from '../assets/award01.png';
import award02 from '../assets/award02.png';
import award03 from '../assets/award03.png';
import award05 from '../assets/award05.png';
import quote from '../assets/quote.png';
import AIRE from '../assets/AIRE.png';

export default {
  bg,
  insideShot,
  gallery01,
  gallery02,
  gallery03,
  gallery04,
  gallery05,
  gallery06,
  gallery07,
  gallery08,
  gallery09,
  gallery10,
  gallery11,
  gallery12,
  gallery13,
  gallery14,
  gallery15,
  gallery16,
  knife,
  menu,
  laurels,
  overlaybg,
  spoon,
  welcome,
  award01,
  award02,
  award03,
  award05,
  quote,
  AIRE,
};
